import { Navigate } from "react-router-dom";
import BoardLoading from "@/components/BoardLoading";
import { useAuth } from "@/auth/AuthContext";

// Front-door enforcement that mirrors the real menu gates. Backend APIs already
// return 403; this blocks page navigation for unauthorized roles and renders the
// protected page ONLY when allowed (no data fetch, no content flash before the
// redirect). Unauthorized navigation redirects to /dashboard.
export default function GuardedRoute({ roles, blockRoles, permission, feature, anyFeatures, children }) {
  const { loading, user, hasPermission, isFeatureEnabled } = useAuth();
  if (loading) return <BoardLoading label="Checking access" />;
  if (!user) return <Navigate replace to="/login" />;
  const role = user.role;
  const denied =
    (roles && !roles.includes(role)) ||
    (blockRoles && blockRoles.includes(role)) ||
    (permission && !hasPermission(permission)) ||
    (feature && !isFeatureEnabled(feature)) ||
    (anyFeatures && !anyFeatures.some((key) => isFeatureEnabled(key)));
  if (denied) return <Navigate replace to="/dashboard" />;
  return children;
}
